/**
 * @module use-cases/product-detail/actions
 * @desc Product Detail Action Creators
 *
 */

import type { ProductDetail } from 'core/services/bff/@types/product-detail/product-detail';
import { createAsyncAction } from 'core/use-cases/utilities';

export const productDetailFetch = createAsyncAction<
  'productDetailFetch',
  { cycle: number; sku: string; isPdp?: boolean },
  ProductDetail['data']['item']
>('productDetailFetch');
